import { db, hasDb } from '@/db';
import { setSync } from './status';

/** Refresh the badge numbers (pending / failed / review) shown by the sync icon. */
export async function refreshCounts(): Promise<void> {
  if (!hasDb()) return;
  const all = await db().outbox.toArray();
  setSync({
    pending: all.filter((o) => o.state === 'pending' || o.state === 'sending').length,
    failed: all.filter((o) => o.state === 'failed').length,
    quarantined: all.filter((o) => o.state === 'quarantined').length,
    rejected: all.filter((o) => o.state === 'rejected').length,
  });
}
